import React, { useState } from 'react';
import './App.css';

function App() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email');
      return;
    }

    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setEmail('');
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setError('Something went wrong. Try again.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Your AI Assistant.</h1>
          <h1 className="highlight">Safe. Deployed.</h1>
          <p className="subheading">No tech skills needed. No safety corners cut.</p>
          
          <div className="cta-section">
            <form onSubmit={handleSubmit} className="email-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitted}
              />
              <button type="submit" disabled={submitted}>
                {submitted ? 'Check your email ✓' : 'Get Early Access'}
              </button>
            </form>
            {error && <p className="error">{error}</p>}
            {submitted && <p className="success">Welcome! Check your inbox.</p>}
          </div>
        </div>
      </section>

      {/* Body Section */}
      <section className="body">
        <div className="container">
          <p className="intro">
            You've seen what AI assistants can do. Now you want one that's truly yours—one that understands your life, your work, your voice.
          </p>
          <p className="intro">
            Most deployment platforms make you choose: easy <em>or</em> safe. We don't.
          </p>
          <p className="intro">
            ShieldClaw handles the complexity. You get the control.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="feature">
            <h3>🔒 Actually Private</h3>
            <p>Your data stays yours. No third-party black boxes.</p>
          </div>
          <div className="feature">
            <h3>⚡ Zero Config</h3>
            <p>Point, click, deployed. That's it.</p>
          </div>
          <div className="feature">
            <h3>🛡️ Built on OpenClaw</h3>
            <p>Open source, auditable, trustworthy.</p>
          </div>
          <div className="feature">
            <h3>🚀 Early Access</h3>
            <p>Be part of the first generation.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 ShieldClaw. All rights reserved.</p>
          <p>
            <a href="https://github.com/openclaw/openclaw" target="_blank" rel="noopener noreferrer">Learn about OpenClaw</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
